import React from 'react';
import userCountry from 'js/services/UserCountry';
import { Link } from '@reach/router';

const BetterExperienceNG = () => {
  return (
    <div className="step">
      <div className="mobile-screen">
        <img src="/images/v2/buyers/better-marketplace.png" alt="A better marketplace experience" className="d-none d-md-inline-block"/>
        <img src="/images/v2/buyers/market-experience-mobile.png" alt="A better marketplace experience" className="d-md-none"/>
      </div>
      <div className="step-content">
        <div className="d-md-flex align-items-md-center">
          <div>
            <h4>A better online buying experience</h4>
            <p>
              When you’re buying on <strong>Instagram</strong>, <strong>Facebook</strong>, <strong>TikTok</strong> or anywhere else,
              PayOnDelivery handles payment and shipping so you don’t have to
            </p>
            <img src="/images/v2/logos-selling-card-ng.svg" alt="Marketplaces" className="w-100"/>
          </div>

          <div>
            {userCountry() !== 'NG' ? <div className="green-square">
              Start buying safely and get the best deals!
            </div>:<div className="green-square-ng">
              Start buying safely and get the best deals!
            </div>}

            <Link to={'/buyer-signup'} className="btn btn-pod btn-inverse btn-block d-none d-md-block">
              Start buying securely
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BetterExperienceNG;
